module.exports = __webpack_public_path__ + "static/media/lafourchette-3.44e33a6a.png";